// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { TextGroupLink } from './text-group-link';
import { TextMessageSent } from './text-message-sent';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TextMessage extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: string;
  body?: string;
  created!: Date;
  fromUserId?: number;
  sent?: Date;
  status!: number;
  fromUser!: User;
  sentLog!: TextMessageSent[];
  textGroupLinks!: TextGroupLink[];
}

